import Cognito from '@/cognito/cognito';
import { clear } from '@/libs/store/common';
import crypto from 'crypto';

export async function signout() {
  const cognito = new Cognito();
  try {
    clear();
    cognito.signout();
  } catch (e) {
    console.log(e);
  }
}

export function alphanumericCheck(v) {
  if (!v) return false;
  const reg = /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/;
  return reg.test(v);
}

export function passwordCheck(v) {
  if (!v) return false;
  const reg = /^(?=.*[!-/:-@[-`{-~])(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[!-~]{8,}$/;
  return reg.test(v);
}

export function alphanumericExceptNullCheck(v) {
  if (!v) return true;
  const reg = /^[a-zA-Z0-9!-/,\s:-@¥[-`{-~]*$/;
  return reg.test(v);
}

export function unitSmallCheck(v, nullOk = false) {
  if (!v && nullOk) return true;
  if (!v || v === 0) return false;
  return v >= 1 && v <= 9;
}

export function unitCheck(v) {
  if (v === 0) return false;
  if (!v) return true;
  return v >= 1 && v <= 100;
}

export function priceCheck(value, nullOk = false) {
  if (!value && nullOk) return true;
  if (value !== 0 && !value) return false;
  return 0 == value || 50 <= value;
}

export function numericCheck(v) {
  if (v === 0) return true;
  if (!v) return false;
  const reg = /^[0-9]*$/;
  return reg.test(v);
}

export function numericCheckNullOk(v) {
  if (!v) return true;
  if (v === 0) return true;
  const reg = /^[0-9]*$/;
  return reg.test(v);
}

export function numCheck(v) {
  if (!v) return false;
  return /^[0-9]*$/.test(v) && 0 <= v && v <= 100;
}

// EmailCheck
export function emailCheck(v, nullOk = false) {
  if (!v && nullOk) return true;
  if (!v) return false;
  const reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
  return reg.test(v);
}

// PhoneNumberCheck
export function phoneNumberCheck(v, nullOk = false) {
  if (!v && nullOk) return true;
  const reg = /^0\d{1,4}-\d{1,4}-\d{3,4}$/;
  return reg.test(v);
}
export function userPhoneNumberCheck(v) {
  if (!v) return true;
  const reg = /^0\d{10}$/;
  return reg.test(v);
}

export function sha256(str: string) {
  return crypto
    .createHash('sha256')
    .update(str, 'utf8')
    .digest('hex')
    .substring(0, 6);
}
